import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { openActionSheet } from 'onsenui'
import { StateServices } from '../../../../services/state.services'
import * as moment from 'moment'
import { User } from '@models/user'
import { TimelineHelper } from '@helpers/timeline.helper'

@Component({
    selector: 'app-client-detail-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['../../../../stagingcss/main-body.component.css',
        './timeline.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../../stagingcss/radial-progress.component.css'],
})

export class TimelineComponent implements OnInit, OnDestroy {
    imageUrl = imageUrl
    en = {}
    showEN = true
    idRoom
    arrList: any [] = []
    getUserId
    pauseVideo = true
    loading = false
    timelineTags = []
    timelineTagsObj = {}
    visibleTimelineTags = []
    activeTag = ''

    jsonSettingBehavior: any = {}

    arrFormTimeline: any[] = []

    updateData: any
    arrayStaffCharge: any[] = []

    enableBehavior: any = 'false'

    deleteData
    currentUser: User;
    private currentClientName: string = ''
    staffNames: Map<string, string> = new Map([['', '']])
    private documentBodyBeforePrint: string = ''
    private documentTitleBeforePrint: string = document.title

    constructor(private auth: AuthService, private stateServices: StateServices, private activatedRoute: ActivatedRoute, private restApi: RestServices, private _sharedService: SharedServices, public matrixServices: MatrixServices) {
        this.activatedRoute.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idRoom = id
        })
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.listCommunicationId(this.idRoom)
        this.currentUser = this.auth.getUser()
        _sharedService.changeEmitted$.subscribe(success => {
            if (success && success[0] === 'loadTimelineNew') {
                const listRoomMessage = success[1]
                this.arrList = listRoomMessage.sort(function(a, b) {
                    return b.visitDate - a.visitDate
                })
                this.filterTags()
                const idActive = success[2]
                if(idActive)
                    this.scrollToTimelineItem(idActive)
                
            }
        })
    }


    ngOnInit() {
        this.getUpdate()
        this.updateDateAfterDelete()
    }

    updateDateAfterDelete() {
        this.deleteData = this.stateServices.changeEmittedDeleteTimeline$.subscribe(res => {
            if (res) {
                this.listCommunicationId(this.idRoom)
                this.stateServices.emitChangeDeleteTimeline(null)
            }
        })
    }

    getUpdate() {
        this.stateServices.emitChangeUpdateAligner(null)
        this.updateData = this.stateServices.changeEmittedUpdateAligner$.subscribe(res => {
            if (res) {
                this.arrList = res['new']
                this.arrList.sort(function(a, b) {
                    return b['visitDate'] - a['visitDate']
                })
                this.filterTags()
                this.stateServices.emitChangeUpdateAligner(null)
            }
        })
    }

    ngOnDestroy() {
        if(this.updateData){
            this.updateData.unsubscribe()
        }
        if(this.deleteData){
            this.deleteData.unsubscribe()
        }
    }

    // convert array of message tags to object
    convertTimelineTagsObject() {
        this.timelineTagsObj = this.timelineTags.reduce(function(acc, cur, i) {
            acc[cur._id] = cur.title
            return acc
        }, {})
    }

    changeActiveTag(item) {
        if (this.activeTag == item) {
            this.activeTag = null
        } else {
            this.activeTag = item
        }
        this.filterTags()
    }

    // filter timeline by message tag
   filterTags() {
    let result = []
    let arr_effect = []
    if (this.activeTag && this.arrList && this.arrList.length > 0) {
        this.arrList.forEach(item => {
            if (item['tags'] && item['tags'].length > 0) {
                if (item['tags'].indexOf(this.activeTag) != -1) {
                    result.push(item)
                }
            }
        })
        arr_effect = result.map(x => Object.assign({}, x))
    } else {
        arr_effect = this.arrList.map(x => Object.assign({}, x))
    }

    const pinned = arr_effect.filter(x => x.isPin)
    const unpinned = arr_effect.filter(x => !x.isPin)

    pinned.sort((a, b) => {
        return b['visitDate'] - a['visitDate']
    })

    unpinned.sort(function (a, b) {
        return b['visitDate'] - a['visitDate']
    })

    const newOrdered = [...pinned, ...unpinned]
 
    if (this.visibleTimelineTags.length === newOrdered.length) {
        this.visibleTimelineTags.splice(0, this.visibleTimelineTags.length, ...newOrdered)
    } else {
        this.visibleTimelineTags = newOrdered
    }

        for (const arrTimeline of this.visibleTimelineTags) {
            if (arrTimeline['type'] === 'form' && arrTimeline['formParam'] && arrTimeline['formParam']['schema'] && arrTimeline['formParam']['schema']['properties']) {
                for (const option2General of arrTimeline['formParam']['schema']['properties']) {
                    if (
                        option2General['schema']
                        && (option2General['schema']['uiType'] === 'button' || option2General['schema']['uiType'] === 'dialog')
                        && (
                            !arrTimeline[option2General['propertyName']]
                            || (
                                option2General['schema']['type'] === 'array'
                                && (arrTimeline[option2General['propertyName']].length === 0 || arrTimeline[option2General['propertyName']].length === option2General['schema']['options'].length)
                            )
                        )
                    ) {
                        option2General.hiddenWhenPrint = true
                    }
                }
            }
        }
    }

    trackByNoteId(index: number, item: any): string {
        return item._id
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    // list timeline
    listCommunicationId(idRoom) {
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const roomId = {}
        roomId['{"clientId":"' + idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObjectWithOutDeleted({
            status: {
                client: {
                    map,
                },
                clientNote: {
                    paths: roomId,
                    searches: roomId,
                },
            },
        })

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const arrSettingAll: any[] = success['response']['setting']['paths']['{}']
                    const findSetting = arrSettingAll.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findSetting) {
                        this.jsonSettingBehavior = findSetting
                        const tmpArrFormTimeline: any[] = this.jsonSettingBehavior['timelineForms'] ? this.jsonSettingBehavior['timelineForms'] : []
                        this.arrFormTimeline = tmpArrFormTimeline.filter(el => {
                            return !el['deleted']
                        })
                    } else {
                        this.jsonSettingBehavior = {}
                        this.arrFormTimeline = []
                    }
                    const listRoomMessage = success['response']['clientNote']['searches']['{"clientId":"' + idRoom + '"}']

                    this.getUserId = success['response']['staff']['paths']['{}']
                    this.arrList = listRoomMessage.sort(function(a, b) {
                        return b.visitDate - a.visitDate
                    })
                    const arrPaths: any[] = success['response']['setting']['paths']['{}']
                    const findBehavior: any = arrPaths.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findBehavior) {
                        if (this.enableBehavior == 'true') {
                            this.timelineTags = findBehavior['noteTag'] || []
                        } else {
                            this.timelineTags = []
                        }
                        this.convertTimelineTagsObject()
                    }
                    this.arrayStaffCharge = success['response']['staff']['paths']['{}']
                    this.staffNames = this.arrayStaffCharge ? new Map<string, string>(
                        this.arrayStaffCharge.map((staff): [string, string] => {
                            const id = staff['_id']
                            const fullName = `${staff['firstName'] || ''} ${staff['familyName'] || ''}`
                            return [id, fullName]
                        })
                    ) : new Map([['', '']])
                    const currentClient = success['response']['client']['map'][idRoom]
                    this.currentClientName = `${currentClient['firstName'] || ''}-${currentClient['familyName'] || ''}`.replace(/ /g, '-')
                    this.filterTags()
                },
            )
        })

    }

    // click show modall timeline
    messageModal(key) {
        if (key === 'message') {
            const arrMessage = [this.idRoom, 'showModalMessageDetail', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'image') {
            const arrMessage = [this.idRoom, 'showModalImageDetail', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'pdf') {
            const arrMessage = [this.idRoom, 'showModalPdfDetail', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'form') {
            if (this.enableBehavior == 'true') {
                const arrayClientInfoUrl = []
                this.arrFormTimeline.forEach((el, i) => {
                    if (!el['deleted']) {
                        const item = {}
                        item['label'] = el['title']
                        item['_id'] = el['_id']
                        arrayClientInfoUrl.push(item)
                    }
                })
                const labelCancel = { label: 'Cancel', icon: 'md-close' }
                arrayClientInfoUrl.push(labelCancel)
                openActionSheet({
                    title: 'Select Forms',
                    cancelable: true,
                    buttons: arrayClientInfoUrl,
                    callback: i => {
                        if (i != -1 && i != arrayClientInfoUrl.length -1) {
                            const emitForm = {}
                            emitForm['action'] = 'create'
                            emitForm['status'] = 'active'
                            emitForm['data'] = this.arrFormTimeline[i]
                            emitForm['tags'] = this.timelineTags
                            emitForm['idClient'] = this.idRoom
                            emitForm['staff'] = this.arrayStaffCharge
                            emitForm['view'] = 'user-timline'
                            this.stateServices.emitChangeDataFormTimeline(emitForm)
                        }
                    },
                })
            }
        } else if (key === 'stl') {
            const arrMessage = [this.idRoom, 'showModalStlDetail', -1, 'create', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        }
    }

    // click edit modal timeline
    editTimeline(key, id, item) {
        if (key === undefined) {
            const arrMessage = [this.idRoom, 'showModalMessageDetail', id, 'edit', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'movie') {
            const arrMessage = [this.idRoom, 'showModalVideo', id, 'edit', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'image') {
            const arrMessage = [this.idRoom, 'showModalImageDetail', id, 'edit', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'pdf') {
            const arrMessage = [this.idRoom, 'showModalPdfDetail', id, 'edit', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        } else if (key === 'form') {
            const emitForm = {}
            emitForm['action'] = 'edit'
            emitForm['status'] = 'active'
            emitForm['data'] = item['formParam'] ? item['formParam'] : this.arrFormTimeline[0]
            emitForm['tags'] = this.timelineTags
            emitForm['idClient'] = this.idRoom
            emitForm['jsonDataSave'] = item
            emitForm['staff'] = this.arrayStaffCharge
            emitForm['view'] = 'user-timline'
            this.stateServices.emitChangeDataFormTimeline(emitForm)
        } else if (key === 'stl') {
            const arrMessage = [this.idRoom, 'showModalStlDetail', id, 'edit', this.timelineTags]
            this._sharedService.emitChange(arrMessage)
        }
    }

    //
    startActivateCard(event) {
        const card = $(event.currentTarget).closest('.card')
        card.addClass('activated')
    }

    stopActivateCard(event) {
        const card = $(event.currentTarget).closest('.card')
        card.removeClass('activated')
    }

    pauseVid(event, pause) {
        const video = event.target
        if (pause) {
            video.play()
            this.pauseVideo = false
        } else {
            video.pause()
            this.pauseVideo = true
        }
    }

    showBigImage(event, id, matrix) {
        event.stopPropagation()
        const arrImage = [id, 'showBigImageDetail', matrix]
        this._sharedService.emitChange(arrImage)
    }

    downloadPdf(event, id, name) {
        event.stopPropagation()

        this.auth.authToken().then(tokenReNew => {
            this.restApi.downloadFile(tokenReNew, id, name)
        })
    }

    downloadStl(event, id, name) {
        event.stopPropagation()

        this.auth.authToken().then(tokenReNew => {
            this.restApi.downloadFile(tokenReNew, id, name)
        })
    }

    handleOnClickNote(note) {
        const checkCanEditNote = this.canEditNote(note)
        if (checkCanEditNote) {
            this.editTimeline(note.type, note._id, note)
        }
    }

    canEditNote(note) {
        return TimelineHelper.canCurrentUserEdit(this.currentUser, note.creator)
    }

    sendMessageRequest(event, arrTimeline) {                
        event.stopPropagation()
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true

        
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: 'update', id: arrTimeline._id, collection: 'clientNote', value: {
                    isPin: !arrTimeline.isPin,
                    pinTimeUpdate: Date.now()
                },
            }], status: {
                clientNote: {
                    paths: clientId, searches: clientId,
                },
            },
            })
                this.auth.authToken().then(tokenReNew => {
                this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                    const listTimeline = success['response']['clientNote']['searches']['{"clientId":"' + this.idRoom + '"}']
                    const arrTimelineNew = ['loadTimelineNew', listTimeline, arrTimeline._id]
                    this._sharedService.emitChange(arrTimelineNew)
                })
            })
       
    }
    
    scrollToTimelineItem(id: string) {
        setTimeout(() => {
            const el = document.getElementById(`timeline-item-${id}`)
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 100)
    }
    
    printHtml() {
        const iframe = document.createElement('iframe')
        iframe.width = '100%'
        iframe.height = '100%'
        document.body.classList.add('print-mode')
        document.body.appendChild(iframe)
        const iframedoc = iframe.contentDocument || iframe.contentWindow.document
        const iframeWindow = iframe.contentWindow
        iframedoc.head.innerHTML = document.head.innerHTML
        const currentTheme = localStorage.getItem('classThemeBody') || ''
        iframedoc.body.classList.add(currentTheme)
        iframedoc.body.innerHTML = document.getElementById('client-detail-timeline').innerHTML
        const oldTitle = document.title
        const fileName = `${this.idRoom}_${this.currentClientName}_${moment().format('YYYYMMDD')}.pdf`
        
        iframeWindow.addEventListener('beforeprint', () => {
            document.title = fileName
            iframedoc.title = fileName

            // need this to calculate exact offsetHeight and offsetWidth for loadImageStylePrint()
            const printForms = iframedoc.querySelectorAll<HTMLDivElement>('.timeline-form-detail-print-mode')
            Array.from(printForms).forEach((div) => {
                div.style.display = 'block'
            })

            const imageWrappers = iframedoc.querySelectorAll<HTMLDivElement>('.timeline-form-detail-print-mode .image-wrapper-print')
            Array.from(imageWrappers).forEach((wrapper) => {
                const [, formIndex, wrapperIndex] = wrapper.id.split('_')
                const image = iframedoc.querySelector<HTMLImageElement>(`.timeline-form-detail-print-mode #imagePrint_${formIndex}_${wrapperIndex}`)
                if (image) {
                    const matrix = image.dataset.matrix.split(',').map(Number)
                    image.style.transform = this.loadImageStylePrint(image, wrapper, matrix)
                }
            })
        })

        iframeWindow.addEventListener('afterprint', () => {
            document.title = oldTitle
            document.body.classList.remove('print-mode')
            document.body.removeChild(iframe)
        })

        setTimeout(() => {
            iframeWindow.print()
            iframeWindow.close()
        }, 2000)
    }

    formatVisitDate(dateString: string) {
        if (moment(dateString, 'YYYY.MM.DD ddd', true).isValid()) {
            return dateString
        }
        
        const date = parseInt(dateString)
        if (isNaN(date)) {
            return ''
        }
        return moment(date).format('YYYY.MM.DD ddd')
    }

    private loadImageStylePrint(imageDOM, containerDOM, matrix) {
        const heightN1 = containerDOM.offsetHeight / imageDOM.clientHeight
        const widthN1 = containerDOM.offsetWidth / imageDOM.clientWidth
        const heightN2 = containerDOM.offsetHeight / imageDOM.clientWidth
        const widthN2 = containerDOM.offsetWidth / imageDOM.clientHeight
        const n1 = (heightN1 > widthN1 ? widthN1 : heightN1) * matrix[0]
        const n2 = (heightN2 > widthN2 ? widthN2 : heightN2) * matrix[1]
        const n3 = (heightN2 > widthN2 ? widthN2 : heightN2) * matrix[2]
        const n4 = (heightN1 > widthN1 ? widthN1 : heightN1) * matrix[3]
        const n5 = (containerDOM.offsetWidth - imageDOM.clientWidth) / 2
        const n6 = (containerDOM.offsetHeight - imageDOM.clientHeight) / 2
        return `matrix(${n1}, ${n2}, ${n3}, ${n4}, ${n5}, ${n6})`
    }

    @HostListener('window:beforeprint')
    onBeforePrint() {
        document.body.classList.add('print-mode')
        this.documentBodyBeforePrint = document.body.innerHTML
        document.body.innerHTML = document.getElementById('client-detail-timeline').innerHTML
        document.title = `${this.idRoom}_${this.currentClientName}_${moment().format('YYYYMMDD')}.pdf`
        const printForms = document.querySelectorAll<HTMLDivElement>('.timeline-form-detail-print-mode')
        Array.from(printForms).forEach((div) => {
            div.style.display = 'block'
        })

        const imageWrappers = document.querySelectorAll<HTMLDivElement>('.timeline-form-detail-print-mode .image-wrapper-print')
        Array.from(imageWrappers).forEach((wrapper) => {
            const [, formIndex, wrapperIndex] = wrapper.id.split('_')
            const image = document.querySelector<HTMLImageElement>(`.timeline-form-detail-print-mode #imagePrint_${formIndex}_${wrapperIndex}`)
            if (image) {
                const matrix = image.dataset.matrix.split(',').map(Number)
                image.style.transform = this.loadImageStylePrint(image, wrapper, matrix)
            }
        })
    }

    @HostListener('window:afterprint')
    onAfterPrint() {
        document.title = this.documentTitleBeforePrint
        document.body.innerHTML = this.documentBodyBeforePrint
        document.body.classList.remove('print-mode')
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/timeline/timeline.component.ts